import { ReactElement, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { OpenStreetMapViewer } from "./common/osm/OpenStreetMapViewer";
import AuthContext from "common/store/AuthContext";
import { useMap } from "common/hooks/useMap";
import { MapSettings } from "common/types/MapSettings";
import { IMapOperation } from "./common/osm/IMapOperation";
import { Coordinates } from "./common/types/MapData";
import { CURSOR } from "./common/osm/components/CursorDrawer";

export type Props = {
  onMapClick?: (position: Coordinates) => void;
  cursorType: CURSOR;
  mapFunctions?: ReactElement[];
};

export const Map2D = (props: Props) => {
  const { selectedPark } = useContext(AuthContext);
  const initializedRef = useRef(false);
  const { getInitialPosition } = useMap();
  const [mapSettings, setMapSettings] = useState<MapSettings>();
  const [loading, setLoading] = useState(true);

  const mapRef = useRef<IMapOperation>(null);

  const initalize = async () => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    if (!selectedPark) {
      setLoading(false);
      return;
    }
    const settings = await getInitialPosition(selectedPark.parkId);
    setMapSettings(settings);
    setLoading(false);
  };

  const handleMapReady = () => {
    if (!mapSettings) return;
    const initialPos = mapSettings.osm.position;
    if (!initialPos) return;
    const { longitude, latitude, zoom } = initialPos;
    mapRef.current?.setPosition({ x: longitude, y: latitude }, zoom);
  };

  useEffect(() => {
    initalize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mapFunctions: ReactElement[] = props.mapFunctions ? [...props.mapFunctions] : [];

  if (loading) {
    return (
      <NoMapDiv>
        <span>読み込み中...</span>
      </NoMapDiv>
    );
  }

  return mapSettings ? (
    <OpenStreetMapViewer
      ref={mapRef}
      onClick={props.onMapClick}
      onReady={handleMapReady}
      cursorType={props.cursorType}
      mapFunctions={mapFunctions}
    />
  ) : (
    <NoMapDiv>
      <span>地図の設定がありません</span>
    </NoMapDiv>
  );
};

const NoMapDiv = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
`;
